// extracted by mini-css-extract-plugin
export default {"cBody":"ContactBody_cBody__vmNQs","header":"ContactBody_header__4Vwce","content":"ContactBody_content__pSPhK"};